<div class="container-fluid">
  <app-sub-header
    pageTitle="Profile"
    [showHistoryToggle]="false"
    [showRagIcon]="false"
    [showAudioIcon]="false"
  />
  <div
    class="row form mx-3"
    [formGroup]="profileForm"
  >
    <div class="col-md-3 mt-5">
      <identity></identity>
    </div>
    <div class="col-md-9 mt-5">
      <div class="mt-3">
        <h2 class="h5 text-primary mb-0">
          {{ sectionLabels.REGION_ROUTE }}
        </h2>
        <app-primary-filter
          #primaryFilterComp
          [dataSource]="filterItems"
          [showApplyActionBlock]="false"
          (changeEvt)="onChangeEvtHandler($event)"
        ></app-primary-filter>
      </div>
      <!-- Alert Subscription -->
      <div class="mt-3">
        <div *ngIf="profilePreference?.alertPreference?.categories">
          <alerts-subscription
            [alerts]="profilePreference.alertPreference.categories"
            [alertsFormGroup]="preferences"
            (alertPreference)="handleAlertPreferenceChange($event)"
          ></alerts-subscription>
        </div>
      </div>

      <!-- Email Subscription -->
      <div class="mt-3">
        <div *ngIf="profilePreference?.subscriptionPreference">
          <email-subscription
            [subscriptions]="profilePreference.subscriptionPreference"
            [emailSubscriptionsForm]="subscriptions"
            (emailPreferenceChange)="handleEmailPreferenceChange($event)"
          ></email-subscription>
        </div>
      </div>
      <div class="d-flex gap-3 mt-2 align-self-start">
        <button
          class="btn btn-primary"
          aria-label="save"
          [disabled]="disableSaveBtn"
          (click)="onSave()"
        >
          {{ sectionLabels.SAVE }}
        </button>
        <button
          class="btn btn-nr-secondary"
          aria-label="cancel"
          [disabled]="disableCancelBtn"
          (click)="onCancel()"
        >
          {{ sectionLabels.CANCEL }}
        </button>
      </div>
    </div>
  </div>
</div>
